import type { Place } from '@cobu/types'

/**
 * The address line shown on place cards and the detail header.
 *
 * `distanceFromBuilding` is a raw float in miles, computed asynchronously
 * server-side. It's null right after creation and stays null permanently for
 * many places (building has no usable Google Place ID, or the place was added
 * via a Maps link with no typed address) — that's "no distance available", not
 * a loading state, and is the common case for most integrated buildings. When
 * null we show the address alone; otherwise we append the distance rounded to
 * one decimal.
 */
export function formatPlaceAddressLine(
  place: Pick<Place, 'street' | 'distanceFromBuilding'>,
): string {
  const distance =
    place.distanceFromBuilding != null ? `${place.distanceFromBuilding.toFixed(1)} miles from here` : ''
  // A place added via a Maps link can have no typed street. Join only the parts
  // that exist so we never render a leading comma or an empty address line.
  if (place.street && distance) return `${place.street}, ${distance}`
  return place.street || distance
}
